import React from 'react';
import QuillDeltaToHtmlConverter from 'quill-delta-to-html';

export default props => {

  const opsInstance = new QuillDeltaToHtmlConverter(props.ops, {});
  const opsRichText = opsInstance.convert();
  return <div className="ql-editor horizontal-screen-any" dangerouslySetInnerHTML={{ __html: opsRichText }}/>;

};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkRichTextOuput.js